import React, {useEffect, useRef} from 'react';
import { Button, makeStyles, Radio, RadioGroup, styled  } from '@mui/material';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const CustomRadio = styled(Radio)(({ theme }) => ({
    color: 'white',
    '&.Mui-checked': {
        color: 'white',
    },
    '& .MuiSvgIcon-root': {
        fontSize: '14px', 
    },
}));

const SFDotsPagination = ({ total, currentIndex, handleDotClick, isMobile }) => {

    const radioRefs = useRef([]);

    useEffect(() => {
        if (radioRefs.current[currentIndex]) {
            radioRefs.current[currentIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }, [currentIndex]);

    return (
        <div className='w-100 d-flex justify-content-between px-3' role='group' aria-label='Assignment navigation' style={{gap: isMobile ? '0px' : '1rem'}}>
            <Button 
            // hidden={isMobile}
            disabled={currentIndex === 0}
            aria-label='Previous assignment'
            style={{ background: '#fff', color: '#bb0000', width:'100px', textAlign:'center', fontWeight: 'bold',
                visibility: currentIndex === 0 ? 'hidden' : 'visible'
            }} 
            variant='contained'  className='cursor-pointer' onClick={() => {
                if (currentIndex !== 0) {
                    handleDotClick(currentIndex - 1)
                }
            }}> 
                <span><MdKeyboardArrowLeft aria-hidden='true' fontSize={20} /></span>
                Previous
            </Button>

            <div className='sf-dots-container d-flex align-items-center overflow-auto' role='radiogroup' aria-label='Select assignment'
            style={{
                gap:'6px', 
                // width: isMobile ? "100%" : "calc(100% - 200px)",
                width: "calc(100% - 200px)",
                justifyContent: total >= 10 ? 'flex-start' : 'center'
            }}
            >

                {total && total > 0 ? Array.from({ length: total }).map((_, index) => {
                    return (
                        <CustomRadio
                            sx={{width:'10px', height:"10px"}}
                            ref={el => radioRefs.current[index] = el}
                            size='small'
                            value={index}
                            checked={currentIndex === index}
                            inputProps={{ 'aria-label': `Assignment ${index + 1} of ${total}` }}
                            onChange={() => handleDotClick(index)}>
                        </CustomRadio>
                    )
                }) : null}
            </div>
            <Button
            // hidden={isMobile}
            disabled={currentIndex === total - 1}
            aria-label='Next assignment'
            style={{ background: '#fff', color: '#bb0000',  width:'100px', textAlign:'center', fontWeight: 'bold',
                visibility: currentIndex === total - 1 ? 'hidden' : 'visible'
             }} 
            variant='contained' 
            className='cursor-pointer' onClick={() => {
                if (currentIndex < total - 1) {
                    handleDotClick(currentIndex + 1)
                }
            }}>
                Next
                <MdKeyboardArrowRight aria-hidden='true' fontSize={20} />
            </Button>
        </div>
    );
}

export default SFDotsPagination;